var React = require('react');

function InlineUnderline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0810546875,4.28027344 C25.2267225,-2.34828249 39.183906,1.56675172 67.3291088,2.38867188 C82.9115465,2.84372347 98.500327,2.02213543 114.085938,1.83886719","id":"Path-2-Copy","stroke":"#CD593C"}));
}

InlineUnderline.defaultProps = {"width":"115px","height":"5px","viewBox":"0 0 115 5","preserveAspectRatio":"none"};

module.exports = InlineUnderline;

InlineUnderline.default = InlineUnderline;
